import {useTranslation} from 'react-i18next';
import SignatureCanvas from 'react-signature-canvas';
import {Col, Row} from 'react-bootstrap';
import {StyledSignature} from './autoBankCharge.styled';
import {useState} from 'react';

export default function Signature({onContinue, onBack}) {
    const {t} = useTranslation();
    const [sigPad, setSigPad] = useState(null);
    const [isSigned, setIsSigned] = useState(false);

    const createSignature = () => {
        const sig = sigPad.getCanvas().toDataURL('image/png');
        onContinue(sig);
    }

    return (
        <StyledSignature>
            <h3>{t('auto_charge.signature')}</h3>
            <div className='sigContainer'>
                <SignatureCanvas
                    penColor='black'
                    canvasProps={{className: 'sigCanvas'}}
                    ref={ref => setSigPad(ref)}
                    onEnd={() => setIsSigned(true)}
                    // temporary measure to detect canvas absence
                    backgroundColor='#EFEFEF'
                />
            </div>
            <Row className="actions">
                <Col sm={3}>
                    <button
                        type="button"
                        className="bllink-button"
                        onClick={onBack}
                    >
                        {t('auto_charge.back')}
                    </button>
                </Col>
                <Col sm={3}>
                    <button
                        type="button"
                        className="bllink-button"
                        onClick={() => {
                            sigPad.clear();
                            setIsSigned(false);
                        }}
                    >
                        {t('auto_charge.clear')}
                    </button>
                </Col>
                <Col sm={3}>
                    <button
                        type="button"
                        className="bllink-button"
                        disabled={!isSigned}
                        onClick={createSignature}
                    >
                        {t('auto_charge.confirm')}
                    </button>
                </Col>
            </Row>
        </StyledSignature>
    );
}